import { useState, useEffect } from 'react';

export const useGoogleMapsServices = () => {
  const [autocomplete, setAutocomplete] = useState<google.maps.places.AutocompleteService | null>(null);
  const [placesService, setPlacesService] = useState<google.maps.places.PlacesService | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.google) {
      setAutocomplete(new google.maps.places.AutocompleteService());
      const dummyElement = document.createElement('div');
      setPlacesService(new google.maps.places.PlacesService(dummyElement));
    }
  }, []);

  return { autocomplete, placesService };
};

export const getPlaceDetails = async (
  placesService: google.maps.places.PlacesService,
  placeId: string
): Promise<google.maps.places.PlaceResult> => {
  return new Promise((resolve, reject) => {
    placesService.getDetails(
      {
        placeId,
        fields: [
          'geometry',
          'formatted_address',
          'place_id',
          'name',
          'formatted_phone_number',
          'website',
          'rating',
          'user_ratings_total',
          'reviews',
          'photos'
        ],
      },
      (result, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && result) {
          resolve(result);
        } else {
          reject(status);
        }
      }
    );
  });
};